<template>
  <el-container class="h-full w-full">
    <el-main v-loading="loading"
      element-loading-text="正在生成合同预览，请稍候"
      element-loading-spinner="el-icon-loading">

    </el-main>
  </el-container>
</template>

<script>
import { 
  fetchSignFlowId,
  fetchSignUrl,
} 
from '@/api/api';

export default {
  name: 'SignPage',
  components: {
  },
  
  data(){
    return {
      profile: {
        userId: 0,
        orgId: 0,
        userName: "",
        orgName: "",
      },
      loading:true,
      bizNo: "",
      refreshCount:0,
      intervalId:0,
    }
  },
  async mounted() {
    try{
      this.bizNo = this.$route.query.biz_no
    }catch(e) {
      console.error("sign mounted: e")
      return
    }
    if( !this.bizNo ) {
      console.error("sign mounted: bizNo is null")
      return
    } 
    this.bizNo = "1-1695367616019941000"
        
    let that = this
    let task = async () => {
        try{
          let resultFlowId = await fetchSignFlowId(that.bizNo)
          if (!resultFlowId || !resultFlowId.data || !resultFlowId.data.data) {
            console.error("fetchSignFlowId error:", resultFlowId)
            return ""
          }
          let resultSignUrl = await fetchSignUrl(resultFlowId.data.data)
          if (!resultSignUrl || !resultSignUrl.data || !resultSignUrl.data.data) {
            console.error("fetchSignUrl error:", resultSignUrl)
            return ""
          }
          return resultSignUrl.data.data
        }catch(err) {
          console.error("sign mounted:", err)
        }
        return ""
    };

    let url = await task()
    if (url !== "") {
      clearInterval(that.intervalId)
      window.location= url
      return
    }
    
    this.intervalId = setInterval(async () => {
      if (that.refreshCount >= 3) {
        clearInterval(that.intervalId)
        console.log("sign mounted: timeout")
        return
      }
      that.refreshCount++;
      url = await task()
      if (url !== "") {
        clearInterval(that.intervalId)
        window.location= url
        return
      }
    }, 3000);
  },
  methods: {
    close() {
      window.close();
    }
  },
}
</script>

<style scoped>
/deep/ .el-icon-loading:before {
  font-size:32px;
}
/deep/ .el-loading-spinner .el-loading-text {
  font-size:16px;
}
/deep/ .el-loading-spinner {
  margin-top:-100px;
}


</style>